module.exports = __webpack_public_path__ + "static/media/icon_qr_code.c17ad39b.svg";